<template>
  <div
    v-loading.fullscreen.lock="loading"
    class="wiki-detail"
    :class="[`${alias}-wiki-detail`]"
    :style="{ marginLeft: showAside ? '85px' : null }"
  >
    <div class="wiki-main-box">
      <div class="wiki-detail-box">
        <!--          // 文章审核中，展示审核提示-->
        <template v-if="isShowLimit">
          <div class="limit-container">
            <template v-if="!loginUid">
              <div class="title">登录后浏览更多内容</div>
              <div class="infos">GameKee健康系统提示您，根据相关规定，您需要登录后才能继续浏览</div>
            </template>
            <div v-if="loginUser && !loginUser.adulthood && loginUser.verify_level === 2" class="tips">
              <img src="@/assets/icons/icon-tips-error.png" alt="" />
              <span>
                Gamekee温馨提示您：
                <br />
                由于您暂未满18岁，该页面内容无法浏览，您可前往首页浏览其它内容～
              </span>
            </div>
            <template v-else>
              <div class="tips">
                温馨提示：
                <br />
                如果您登录的账号是未成年人（未满18岁）的身份信息将会
                <br />
                受到以下影响
              </div>
              <div class="text">【部分内容无法完全浏览】</div>
            </template>

            <div class="button-option">
              <div class="btn borderd" @click="goBackHome">回到首页</div>
              <div
                class="btn"
                v-if="!loginUid || (loginUser && !loginUser.adulthood && loginUser.verify_level !== 2)"
                @click="handleVerify"
              >
                实名认证
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="detail.isUnderReview && detail.isUnderReview === 1">
          <detail-review />
        </template>
        <template v-else-if="detail.audit_state === -1">
          <detail-disabled :detail="detail"></detail-disabled>
        </template>
        <template v-else>
          <div class="main-content">
            <article class="wiki-detail-body">
              <!-- 文章标题 -->
              <detail-title :detail="detail"></detail-title>
              <!-- 文章描述 -->
              <detail-desc :detail="detail"></detail-desc>
              <!-- 正文内容 -->
              <template v-if="detail && detail.id > 0">
                <!-- 老编辑器 -->
                <detail-content v-if="detail.editor_type == 0" :content-data="detail" />
                <!-- 新编辑器 -->
                <detail-json-content v-if="detail.editor_type == 1" :content-data="detail" />
                <!-- 图鉴编辑器 -->
                <book-content
                  v-if="detail.editor_type == 2"
                  mode="view"
                  :content-data="formatContentData(detail.content_json)"
                />
              </template>
            </article>
            <!-- 正文底部 -->
            <detail-footer :detail="detail" @refresh="refresh"></detail-footer>
            <!-- 相关推荐 -->
            <!-- <detail-recommend :recommend-list="recommendList"></detail-recommend> -->
            <!-- 帖子表情包 -->
            <DetailEmojiBar :detail="detail" @emojiCheck="onEmojiCheck" />
            <!-- 赞赏 -->
            <DetailReward :detail="detail" />
            <!-- 底部评论 -->
            <div class="comment-box">
              <div class="title">评论（{{ detail.comment_count }}）</div>
              <DetailComment
                :isPage="true"
                :detail="detail"
                :list="list"
                :pagination="pagination"
                @refresh="refresh"
                @getCommentList="getCommentList"
              />
            </div>
            <!-- <div class="no-more">
              没有更多数据了
            </div> -->

            <!-- 返回 -->
            <detail-back :position="position"></detail-back>
            <!-- 返回首页 -->
            <detail-back-home :position="position" @goBackHome="goBackHome"></detail-back-home>
            <!-- 目录 -->
            <detail-catalog :detail="detail" :position="position" @refresh="refresh"></detail-catalog>
            <!-- 右侧边栏 -->
            <DetailAside
              v-show="!dialogVisible"
              :detail="detail"
              :commentList="list"
              :commentPagination="pagination"
              :position="position"
              :hasPageFooter="false"
              @refresh="refresh"
              @getCommentList="getCommentList"
              @showAside="handleShowAside"
              @comment="onClickComment"
              @share="onClickShare"
            />
            <!-- 滚动到顶部 -->
            <detail-scroll-top :position="position" />
          </div>
        </template>
      </div>
    </div>
    <el-dialog
      :title="`评论（${detail.comment_count}）`"
      :visible.sync="dialogVisible"
      width="684px"
      :close-on-click-modal="true"
      custom-class="comment-dialog"
      top="10vh"
    >
      <!-- 帖子表情包 -->
      <div style="margin-bottom: 22px;">
        <DetailEmojiBar :detail="detail" @emojiCheck="onEmojiCheck" />
      </div>
      <DetailComment
        ref="commentRef"
        :detail="detail"
        :list="list"
        :pagination="pagination"
        @refresh="refresh"
        @getCommentList="getCommentList"
      />
      <div class="fllow-body" :style="fllowBodyStyle">
        <div class="item" @click="onLike">
          <img
            class="icon"
            :src="
              `${
                detail.is_like
                  ? require('@/assets/images/aside_dianzanle.png')
                  : require('@/assets/images/aside_dianzan.png')
              }`
            "
          />
          <span class="txt">{{ formatCount(detail.like_count) }}</span>
        </div>
        <div class="item" @click="onFavorite">
          <img
            class="icon"
            :src="
              `${
                detail.is_favorite
                  ? require('@/assets/images/aside_shoucangle.png')
                  : require('@/assets/images/aside_shoucang.png')
              }`
            "
          />
          <span class="txt">{{ formatCount(detail.favorite_count) }}</span>
        </div>
        <div class="item" @click="onShare">
          <img class="icon" :src="`${require('@/assets/images/aside_fenxiang.png')}`" />
          <span class="txt">分享</span>
        </div>
      </div>
    </el-dialog>
    <ShareView ref="shareViewRef"></ShareView>
    <AdultCheck ref="adultCheckRef" />
  </div>
</template>

<script>
import Clipboard from "clipboard";

import { mapGetters } from "vuex";
// plugins
import eventBus from "@/plugins/eventBus";
import { getJumpWikiDetailUrl, isInViewPort, debounce } from "@/plugins/util";
// components

import DetailTitle from "./components/detailTitle";
import DetailDesc from "./components/detailDesc";
import DetailContent from "./components/detailContent";
import DetailJsonContent from "./components/detailJsonContent";
import DetailFooter from "./components/detailFooter";
import BookContent from "@/views/editor/wiki-editor/illustrated-book/BookContent";
import DetailReview from "./components/detailReview";
import DetailDisabled from "./components/detailDisabled";
import DetailCatalog from "./components/detailCatalog";
import DetailAside from "./components/detailAside.vue";
import DetailBack from "./components/detailBack";
import DetailBackHome from "./components/detailBackHome.vue";
// import DetailRecommend from "./components/detailRecommend";
import DetailScrollTop from "./components/detailScrollTop.vue";
import DetailComment from "./components/detailComment.vue";
import DetailEmojiBar from "./components/detailEmojiBar.vue";
import DetailReward from "./components/detailReward.vue";
// api
import { apiContentDetail, apiGetRecommend, apiVersionDetail, apiContentLike } from "@/api/contentApi";
import { apiCommentList } from "@/api/commentApi";
import { apiUserAddFavorite } from "@/api/userApi";
// mixins
import mergeAsyncDataMixin from "@/mixins/mergeAsyncDataMixin";
import ShareView from "./components/shareView.vue";
import AdultCheck from "@/layout/wiki/components/adultCheck.vue";

export default {
  name: "detail",
  mixins: [mergeAsyncDataMixin],
  props: {},
  model: {},
  components: {
    DetailTitle,
    DetailDesc,
    DetailContent,
    DetailJsonContent,
    DetailFooter,
    DetailCatalog,
    BookContent,
    DetailReview,
    DetailDisabled,
    DetailAside,
    DetailBack,
    // DetailRecommend,
    DetailScrollTop,
    DetailComment,
    DetailEmojiBar,
    ShareView,
    DetailBackHome,
    AdultCheck,
    DetailReward
  },
  data() {
    return {
      loading: false,
      prevRoute: null,
      hasHistory: true,
      dialogVisible: false,
      // 详情
      isSSRGetData: false,
      detail: {
        user: { uid: 0 }
      },
      user: {
        avatar: "",
        uid: 0,
        username: "",
        is_followed: 0
      },
      // 评论列表
      list: [],
      pagination: {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      loadCommentStatus: "",
      // 相关推荐
      recommendList: [],
      // 是否首次滚动页面
      isFirstScroll: false,
      isFirstScrollToComment: false,
      firstScrolTime: 0,
      firstReadTime: 0,
      showAside: false,
      position: null,
      fllowBodyStyle: {},
      routerFrom: {},
      isShowLimit: false
    };
  },
  async asyncData({ router, store, ssrContext, $apis }) {
    try {
      console.log("asyncData start");
      const route = router.currentRoute;
      const routeMeta = route.meta;
      // 数据预取
      const gameInfo = store.getters.gameInfo;
      let { params } = router.currentRoute;
      let detail = {
        user: { uid: 0 }
      };
      let isShowLimit = false;
      let user = {
        avatar: "",
        uid: 0,
        username: "",
        is_followed: 0
      };
      let list = [];
      let recommendList = [];
      let pagination = {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      };

      if (params.id.includes("_")) {
        let ids = params.id.split("_");
        const { code, data } = await $apis.apiVersionDetail({
          id: ids[1]
        });
        if (code == 0) {
          detail = data;
          user = detail.user;
        }
      } else {
        const res = await Promise.all([
          // 详情
          $apis.apiContentDetail({
            id: params.id
          }),
          // 评论
          $apis.apiCommentList({
            ...pagination,
            content_id: Number(params.id)
          }),
          // 推荐
          $apis.apiGetRecommend({
            id: params.id,
            limit: 9,
            get_adv: false
          })
        ]).catch(err => {
          if (err.code === 50001) {
            isShowLimit = true;
          }
        });
        if (res) {
          // 详情
          const { code: detailResCode, data: detailResData } = res[0];
          if (detailResCode == 0) {
            detail = detailResData;

            user = detail.user;
            if (detail.editor_type == 3) {
              ssrContext.redirectURL = getJumpWikiDetailUrl(detail.game.alias, detail.game.id, params.id, false, true);
              return;
            }
            // 文章关联wiki和当前wiki不匹配，返回对应wiki详情；
            if (!routeMeta.noWikiRoute && detail.game.alias != gameInfo.alias) {
              const url = getJumpWikiDetailUrl(detail.game.alias, detail.game.id, params.id);
              ssrContext.redirectURL = url;
              return;
            }
          }
          // 评论
          const { code: commentResCode, data: commentResData, meta: commentResMeta } = res[1];
          if (commentResCode == 0) {
            list = commentResData || [];
            pagination = commentResMeta.pagination;
            detail.comment_count = commentResMeta.pagination.total;
          }
          // 推荐内容
          const { code: recommendResCode, data: recommendResData } = res[2];
          if (recommendResCode == 0) {
            recommendList = recommendResData || [];
          }
        }
      }

      // TDK设置
      if (detail) {
        const isWww = store.getters.isWww;
        if (isWww) {
          ssrContext.title = detail.title + "|Gamekee";
        } else {
          ssrContext.title = `${detail.game && detail.game.name}${detail.title}_${detail.game &&
            detail.game.name}wiki|GameKee`;
          // 判断是否新图鉴
          if (detail.editor_type == 2) {
            ssrContext.keywords = detail.title;
          } else {
            ssrContext.keywords = "";
          }
          ssrContext.description = detail.summary;
        }
        // 自定义编辑的TDK
        if (detail.seo && detail.seo_format) {
          const seo = detail.seo_format;
          if (seo.title) {
            ssrContext.title = seo.title;
          }
          if (seo.key) {
            ssrContext.keywords = seo.key;
          }
          if (seo.desc) {
            ssrContext.description = seo.desc;
          }
        }
      }

      console.log("asyncData end");
      return {
        detail,
        user,
        recommendList,
        list,
        pagination,
        isSSRGetData: true,
        isShowLimit
      };
    } catch (err) {
      let detail = {
        user: { uid: 0 }
      };
      if (err && err.code == 1002 && err.msg == "文章不存在: record not found") {
        // 没有文章信息，重定向到404
        ssrContext.redirectURL = "/404";
      } else if (err && err.code === 100002) {
        // 文章审核中，展示审核提示
        detail = {
          isUnderReview: 1
        };
      } else if (err && err.code === 100010) {
        // 文章被禁用
        detail = {
          audit_state: -1
        };
      }
      return {
        detail,
        isSSRGetData: true
      };
    }
  },
  computed: {
    ...mapGetters(["loginUser", "loginUid", "gameInfo", "device"])
  },
  watch: {
    $route: "init",
    detail: {
      immediate: true,
      handler(object) {
        if (this.$isServer) return;
        console.log(JSON.parse(JSON.stringify(object)));
      }
    }
  },
  beforeMount() {
    // 服务端已获取数据
    if (!this.isSSRGetData) {
      this.init();
    }
    // 将服务端数据置空，防止动态切换默认渲染此数据
    this.$store.commit("set_ssr_component_data", []);
  },
  async mounted() {
    // 服务端已获取数据
    if (this.isSSRGetData) {
      if (this.isShowLimit) {
        if (!this.loginUid || this.loginUid == 0) {
          eventBus.$emit("onShowLogin");
        } else if (this.loginUser && !this.loginUser.adulthood && this.loginUser.verify_level !== 2) {
          this.$refs.adultCheckRef.visible = true;
        }
      }
    }

    this.firstReadTime = Date.now();
    await this.$nextTick();
    if (history.length > 1) {
      this.hasHistory = true;
    } else {
      this.hasHistory = false;
    }
    // if (!this.isHeroGame && this.device.height > 600) {
    //   (adsbygoogle = window.adsbygoogle || []).push({});
    // }
    window.addEventListener("resize", () => {
      this.watchPosition();
    });
    this.watchPosition();
    setTimeout(() => {
      // 监听页面滚动,埋点上报
      window.addEventListener("scroll", this.pageScroll);
    }, 100);
  },
  beforeDestroy() {
    window.staticFn && window.staticFn.customEvent("read_detail", { value: Date.now() - this.firstReadTime });
    window.removeEventListener("scroll");
  },
  methods: {
    watchPosition() {
      const detailEl = document.querySelector(".wiki-detail");
      if (!detailEl) return;
      const detailPostion = detailEl.getBoundingClientRect();
      this.position = {
        left: detailPostion.left,
        top: detailPostion.top,
        right: detailPostion.right,
        bottom: detailPostion.bottom
      };
    },
    handleShowAside(isShow) {
      this.showAside = isShow;
      this.$nextTick(() => {
        this.watchPosition();
      });
    },
    // 页面滚动
    pageScroll() {
      this.watchPosition();
      this.loadMoreComment();
      if (window.staticFn) {
        if (!this.isFirstScroll) {
          this.isFirstScroll = true;
          this.firstScrolTime = Date.now();
          window.staticFn.customEvent("scroll_detail_first");
        }

        if (!this.isFirstScrollToComment) {
          const commentEl = document.querySelector(".wiki-detail-comment");
          if (commentEl && isInViewPort(commentEl, -20)) {
            // 判断是否滚动到评论区
            this.isFirstScrollToComment = true;
            const duration = Date.now() - this.firstScrolTime;
            window.staticFn.customEvent("scroll_detail_comment", { value: duration });
          }
        }
      }
    },
    /** 页面滚动到底部时加载更多评论 */
    loadMoreComment: debounce(function() {
      if (
        document.scrollingElement.scrollHeight -
          document.scrollingElement.scrollTop -
          document.scrollingElement.clientHeight <
        100
      ) {
        this.getCommentList();
      }
    }, 300),
    // 设置loading
    setLoading(loading) {
      this.loading = loading;
    },
    // 刷新详情
    refresh(detail, user) {
      // 将服务端数据置空，防止动态切换默认渲染此数据
      this.$store.commit("set_ssr_component_data", []);
      if (detail) {
        this.$set(this, "detail", detail);
      }
      if (user) {
        this.$set(this, "user", user);
      }
    },
    goBackHome() {
      this.$store.commit("set_ssr_component_data", []);
      this.$router.replace(`/${this.alias}`).then(() => {
        // this.$router.go(0)
        window.location.reload();
      });
    },
    // 格式化图鉴数据
    formatContentData(content_json) {
      try {
        const contentJson = JSON.parse(content_json || "");
        if (Array.isArray(contentJson)) {
          return contentJson;
        }
        return contentJson.children;
      } catch (error) {
        console.log(error);
      }
    },
    formatCount(count) {
      if (count > 100000000) {
        const num = count / 100000000;
        if (num == (count / 100000000).toFixed(1)) {
          return num + "亿";
        } else {
          return (count / 100000000).toFixed(1) + "亿+";
        }
      } else if (count >= 10000) {
        const num = count / 10000;
        if (num == (count / 10000).toFixed(1)) {
          return num + "W";
        } else {
          return (count / 10000).toFixed(1) + "W+";
        }
      } else if (count >= 1000) {
        const num = count / 1000;
        if (num == (count / 1000).toFixed(1)) {
          return num + "K";
        } else {
          return (count / 1000).toFixed(1) + "K+";
        }
      } else {
        return count;
      }
    },
    // 获取文章详情
    async getDetail() {
      let { params } = this.$route;
      let id = params.id.split("_")[0];
      // this.detail = { user: { uid: 0 } };
      // return;
      await apiContentDetail({ id })
        .then(async res => {
          if (res.code == 0) {
            this.detail = res.data;
            const routeMeta = this.$route.meta;
            if (this.detail.editor_type == 3) {
              const url = getJumpWikiDetailUrl(this.detail.game.alias, this.detail.game.id, params.id, false, true);
              window.location.replace(url);
              return;
            }
            if (this.detail.editor_type == 4) {
              const url = getJumpWikiDetailUrl(this.detail.game.alias, this.detail.game.id, params.id, false, "zbtj");
              window.location.replace(url);
              return;
            }
            // 文章关联weiki和当前wiki不匹配，返回对应wiki详情；
            if (!routeMeta.noWikiRoute && this.detail.game.alias != this.gameInfo.alias) {
              const url = getJumpWikiDetailUrl(this.detail.game.alias, this.detail.game.id, id);
              window.location.replace(url);
              return;
            }
            this.user = this.detail.user;
            // eventBus.$emit('setDetailContent', res.data);
            await this.getCommentList();
          }
        })
        .catch(err => {
          if (err.code === 50001) {
            this.isShowLimit = true;
            if (!this.loginUid) {
              eventBus.$emit("onShowLogin");
            } else if (this.loginUser && !this.loginUser.adulthood && this.loginUser.verify_level !== 2) {
              this.$refs.adultCheckRef.visible = true;
            }
            return;
          }
          // 文章审核中
          if (err && err.code === 100002) {
            this.detail = {
              isUnderReview: 1
            };
            return;
          }
          // 文章禁用
          if (err && err.code === 100010) {
            this.detail = {
              audit_state: -1
            };
            return;
          }
          if (err && err.code == 1002 && err.msg == "文章不存在: record not found") {
            // 没有文章信息，重定向到404
            this.$router.replace("/404");
          }
        });
    },
    // 获取推荐
    getRecommend() {
      let { params } = this.$route;
      let id = params.id.split("_")[0];
      let param = {
        id,
        limit: 9,
        get_adv: false
      };
      apiGetRecommend(param).then(res => {
        if (res.code === 0) {
          this.recommendList = res.data || [];
        }
      });
    },
    // 获取历史记录详情
    async getLogDetail() {
      let { params } = this.$route;
      let id = params.id.split("_")[1];

      await apiVersionDetail({ id })
        .then(async res => {
          this.detail = res.data;
          this.user = this.detail.user;
          eventBus.$emit("setDetailContent", res.data);
        })
        .catch(err => {
          // 文章审核中
          if (err && err.code === 100002) {
            this.detail = {
              isUnderReview: 1
            };
          }
        });
    },
    // 获取评论
    async getCommentList(type) {
      const { id = "" } = this.$route.params;
      if (id.includes("_")) return;
      if (type == "refresh") {
        this.pagination = {
          limit: 10,
          page_no: 0,
          page_total: 1,
          total: 0
        };
        this.list = [];
      }
      let { pagination } = this;
      if (pagination.page_no >= pagination.page_total) {
        this.loadCommentStatus = "end";
        return;
      }
      ++pagination.page_no;
      let params = {
        ...pagination,
        content_id: Number(id)
      };
      this.loadCommentStatus = "loading";
      await apiCommentList(params)
        .then(res => {
          if (res.code == 0) {
            this.list = this.list.concat(res.data);
            this.pagination = res.meta.pagination;
            // if (this.list.length > 2 && this.pagination.page_no == 1) {
            // }
          }
        })
        .finally(_ => {
          this.loadCommentStatus = "";
        });
    },
    // 初始化
    async init() {
      let { params } = this.$route;
      this.logList = [];
      this.logPagination = {
        limit: 10,
        page_no: 1,
        page_total: 1,
        total: 0
      };
      if (params.id.includes("_")) {
        await this.getLogDetail();
      } else {
        await this.getDetail();
      }
      this.getRecommend();
    },
    onClickComment() {
      this.dialogVisible = true;
    },
    onClickShare() {
      this.$refs.shareViewRef.open(this.detail);
    },
    onLike() {
      // if (!this.isLogin()) {
      //   return false;
      // }
      let params = {
        is_like: this.detail.is_like ? 0 : 1,
        origin_id: this.detail.id,
        type: 1
      };
      apiContentLike(params).then(res => {
        this.detail.is_like = params.is_like;
        params.is_like ? this.detail.like_count++ : this.detail.like_count--;
        if (this.detail.like_count < 0) this.detail.like_count = 0;
        this.$emit("refresh", this.detail);
      });
    },
    onFavorite() {
      if (!this.isLoginShow()) return false;
      let params = {
        origin_id: this.detail.id,
        type: 1
      };
      apiUserAddFavorite(params).then(res => {
        if (res.code == 0) {
          this.detail.is_favorite = this.detail.is_favorite ? 0 : 1;
          this.detail.is_favorite ? this.detail.favorite_count++ : this.detail.favorite_count--;
          this.$emit("refresh", this.detail);
        }
      });
    },
    onShare() {
      let shareText = `${this.detail.user.username}分享了文章:${this.detail.title}\r\n`;
      shareText += window.location.href + "\r\n";
      shareText += "来自GameKee";

      let $div = document.createElement("div");
      $div.setAttribute("data-clipboard-text", shareText);
      $div.classList.add("page-share-copy-btn");
      document.body.appendChild($div);
      let clipboard = new Clipboard(".page-share-copy-btn");
      clipboard.on("success", e => {
        this.$message("复制成功！");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message("浏览器不支持自动复制,请更换其他浏览器");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      $div.click();
    },
    handleVerify() {
      if (!this.loginUid) {
        eventBus.$emit("onShowLogin");
      } else {
        this.$refs.adultCheckRef.visible = true;
      }
    },
    /** 点击帖子底部某个表情也视为点赞 */
    onEmojiCheck() {
      if (this.detail.is_like === 0) {
        this.detail.like_count++;
      }
      this.detail.is_like = 1;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .comment-dialog {
  border-radius: 16px;
  .el-dialog__header {
    padding: 20px 32px 0;
    .el-dialog__headerbtn {
      right: 32px;
      top: 22px;
    }
  }
  .el-dialog__body {
    padding: 22px 32px;
  }
}
.wiki-detail {
  width: 960px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: -8px;

  .wiki-main-box {
    position: relative;
    width: 100%;
    background: rgba(174, 181, 203, 0.45);
    border-radius: 12px;
    padding: 6px;
    border-radius: 12px;
  }
}

.ba-wiki-detail {
  padding-top: 16px;
}

.wiki-detail-box {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  padding: 17px 35px;
  border-radius: 12px;
  min-height: 100vh;
  .limit-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 80px;
    .title {
      font-weight: 500;
      font-size: 28px;
      color: #333333;
    }
    .infos {
      margin-top: 30px;
      margin-bottom: 42px;
      // font-weight: bold;
      font-size: 24px;
      color: rgba(51, 51, 51, 0.9);
    }
    .tips {
      // font-weight: 500;
      font-size: 20px;
      color: rgba(51, 51, 51, 0.85);
      line-height: 22px;
      text-align: center;
      img {
        width: 18px;
        height: 18px;
      }
    }
    .text {
      margin-top: 24px;
      font-size: 16px;
      color: rgba(51, 51, 51, 0.65);
      text-align: center;
    }
    .button-option {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 32px;
      gap: 0 15px;
      .btn {
        width: 260px;
        height: 42px;
        border-radius: 22px;
        line-height: 42px;
        text-align: center;
        color: #fff;
        font-size: 16px;
        box-sizing: border-box;
        background-color: #198ff8;
        cursor: pointer;
      }
      .borderd {
        background: #fff;
        border: 2px solid #198ff8;
        color: #198ff8;
      }
    }
  }

  .main-content {
    width: 100%;
    .wiki-detail-body {
      width: 100%;
      border-radius: 2px;
    }
  }
}

/deep/ .comment-box {
  margin-top: 30px;
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #424242;
    line-height: 52px;
    margin-bottom: 10px;
  }
}

.no-more {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  text-align: center;
  padding: 33px 0 13px 0;
}

.fllow-body {
  position: absolute;
  bottom: 20px;
  right: -74px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  .item {
    width: 58px;
    height: 58px;
    border-radius: 30px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 14px;
    cursor: pointer;
    .icon {
      font-size: 0;
      width: 28px;
      height: 28px;
    }
    .txt {
      color: #424242;
      font-size: 11px;
    }
  }
}
</style>
